import Navbar from "./components/NavBar/navbar";
import Intro from "./components/Intro/intro";
import Experience from "./components/Experience/experience";
import Skills from "./components/Skills/skills";
import Contact from "./components/Contact/contact";
import Footer from "./components/Footer/footer";
import Project from "./components/Projects/project";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Intro />
      <Experience />
      <Skills />
      <Project />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
